import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported

const Endueuro = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Endo Urology Care</h1>
        <p className="text-justify">
          Endo Urology is a field of urology that involves minimally invasive surgical techniques 
          performed through small incisions or natural body openings. This advanced approach allows 
          for the treatment of conditions that traditionally require open surgery, offering patients 
          several benefits, such as reduced risk of infection, shorter recovery time, and less 
          post-operative pain.
        </p>
        <h2 className="mt-5">Adrenal Tumors</h2>
        <p className="text-justify">
          Adrenal tumors can be either benign (non-cancerous) or malignant (cancerous), and they can 
          disrupt the production of essential hormones like adrenaline and cortisol. These hormones 
          regulate vital functions such as blood pressure, metabolism, and stress response.
        </p>
        <p className="text-justify">
          For adrenal tumors, we utilize state-of-the-art imaging tools such as CT scans and MRIs to 
          precisely locate the tumor. Minimally invasive laparoscopic surgery is then employed to remove 
          the tumor through small incisions, which significantly reduces recovery time and post-operative 
          pain. This approach ensures the best possible outcomes while preserving surrounding healthy tissues.
        </p>
        <h2 className="mt-5">Kidney Cancer</h2>
        <p className="text-justify">
          Kidney cancer, including renal cell carcinoma, is a serious condition that can spread rapidly if 
          not treated in its early stages.
        </p>
        <p className="text-justify">
          The preferred treatment for kidney cancer involves laparoscopic and robotic-assisted nephrectomy. 
          These techniques use small incisions and advanced robotics to remove cancerous tissue with precision, 
          all while preserving as much healthy kidney tissue as possible. Early diagnosis and prompt treatment 
          are crucial for effective management and improved patient outcomes.
        </p>
        <h2 className="mt-5">Supine PCNL (Percutaneous Nephrolithotomy)</h2>
        <p className="text-justify">
          Supine PCNL is an advanced technique used to remove large kidney stones that cannot be treated with 
          other methods. Unlike traditional PCNL, which is done with the patient lying face down, supine PCNL 
          is performed with the patient lying on their back, offering several benefits.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default Endueuro;
